import React from "react";
import Slider from "react-slick";

function GallerySlider() {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <Slider {...settings}>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item1.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item2.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item3.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item4.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item5.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item6.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item7.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item8.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            <div>
                <div className="flex items-center justify-center h-[465px]">
                    <img src="/assets/gallery/item1/item9.jpeg" alt="" className="max-w-[98%] h-[220px] object-cover w-full" />
                </div>
            </div>
            
        </Slider>
    );
}

export default GallerySlider;
